export default "__VITE_ASSET__CR$SBw_A__"